/**
 * What a contact's standing gives at a price tag or a payout (WP-X1, shared/contacts.ts). A light helper for
 * the systems that sell things (Halloran's workshop, Sid's counter, Pike's, the desk sergeant, the minicab):
 * no contacts service (a test rig without it) means no perk.
 */
import type { GameContext } from '../core/context';
import { discounted, type PerkKey } from '../../shared/contacts';

/** The fraction the standing gives for `key` (0 = nothing). */
export function contactPerk(ctx: GameContext, key: PerkKey): number {
  return ctx.services.tryGet('contacts')?.perk(key) ?? 0;
}

/** `base` after the standing's discount for `key` (whole pounds). */
export function contactPrice(ctx: GameContext, key: PerkKey, base: number): number {
  const f = contactPerk(ctx, key);
  return f > 0 ? discounted(base, f) : base;
}
